export const GET_ANNOUNCEMENT = 'GET_ALL_ANNOUNCEMENT';
export const SET_HAVE_NEW_NOTIF = 'SET_HAVE_NEW_NOTIF';

const initialState = {
  announcements: [],
  haveNewNotif: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_ANNOUNCEMENT: {
      return {
        ...state,
        announcements: action.payload,
      };
    }

    case SET_HAVE_NEW_NOTIF:
      return {
        ...state,
        haveNewNotif: action.payload.data,
      };

    default:
      return state;
  }
}
